// Mock data for Rotativa Gaúcha

export const companyInfo = {
  name: "Rotativa Gaúcha",
  slogan: "Tradição e qualidade no seu churrasco bagual!",
  description: "Somos uma empresa pra lá de bagual! Fabricamos churrasqueiras rotativas de alta qualidade, feitas especialmente para costelões e o verdadeiro churrasco gaúcho.",
  whatsapp: "5555999636275",
  whatsappDisplay: "(55) 99963-6275",
  instagram: "https://www.instagram.com/rotativagaucha/",
  location: "Panambi, RS",
  fullAddress: "Panambi - Rio Grande do Sul, Brasil"
};

export const products = [
  {
    id: 1,
    name: "Rotativa em Ação",
    description: "Veja nossa rotativa funcionando! Ideal para costelões e churrascos grandes. A carne fica no ponto perfeito!",
    features: ["Giro automático", "Assamento uniforme", "Capacidade para grandes cortes"],
    image: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/flk0mvrh_WhatsApp%20Image%202026-01-24%20at%2021.27.04%281%29.jpeg",
    price: "Consulte",
    tag: "Mais Vendida"
  },
  {
    id: 2,
    name: "Rotativa Inox Premium",
    description: "Modelo premium 100% em aço inoxidável com motor de alta durabilidade. Acabamento impecável!",
    features: ["100% Inox", "Motor resistente", "Rodinhas para transporte"],
    image: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/jn7ukzsx_WhatsApp%20Image%202026-01-24%20at%2021.27.04%284%29.jpeg",
    price: "Consulte",
    tag: "Premium"
  },
  {
    id: 3,
    name: "Rotativa Inox Completa",
    description: "Modelo completo em inox com grelha reforçada. Máxima durabilidade para seu churrasco bagual!",
    features: ["Estrutura robusta", "Grelha reforçada", "Fácil limpeza"],
    image: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/l3nkk6gm_WhatsApp%20Image%202026-01-24%20at%2021.27.04%283%29.jpeg",
    price: "Consulte",
    tag: null
  },
  {
    id: 4,
    name: "Rotativa Tradicional",
    description: "O modelo clássico que não falha! Robusta e confiável para o churrasco de todo dia.",
    features: ["Design clássico", "Alta resistência", "Ótimo custo-benefício"],
    image: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/9h4phi1r_WhatsApp%20Image%202026-01-24%20at%2021.27.04%282%29.jpeg",
    price: "Consulte",
    tag: null
  }
];

export const benefits = [
  {
    icon: "Flame",
    title: "Qualidade Bagual",
    description: "Produtos fabricados com materiais de primeira linha para durar por gerações."
  },
  {
    icon: "Shield",
    title: "Garantia de Fábrica",
    description: "Todos os produtos com garantia. Sua satisfação é nossa prioridade."
  },
  {
    icon: "Truck",
    title: "Enviamos para Todo Brasil",
    description: "Entregamos sua rotativa em qualquer lugar do país com segurança."
  },
  {
    icon: "Wrench",
    title: "Suporte Técnico",
    description: "Atendimento personalizado e suporte para tirar todas as suas dúvidas."
  }
];

export const testimonials = [
  {
    name: "João Silva",
    location: "Porto Alegre, RS",
    text: "Melhor investimento que fiz! O costelão fica perfeito e a rotativa é muito resistente.",
    rating: 5
  },
  {
    name: "Carlos Mendes",
    location: "Caxias do Sul, RS",
    text: "Atendimento excelente e produto de qualidade. Super recomendo a Rotativa Gaúcha!",
    rating: 5
  },
  {
    name: "Roberto Santos",
    location: "Santa Maria, RS",
    text: "Comprei a versão em inox e não me arrependo. Qualidade impecável!",
    rating: 5
  }
];

export const galleryImages = [
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/dvye961w_image.png",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/flk0mvrh_WhatsApp%20Image%202026-01-24%20at%2021.27.04%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/jn7ukzsx_WhatsApp%20Image%202026-01-24%20at%2021.27.04%284%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/l3nkk6gm_WhatsApp%20Image%202026-01-24%20at%2021.27.04%283%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/9h4phi1r_WhatsApp%20Image%202026-01-24%20at%2021.27.04%282%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/9jhqhz03_WhatsApp%20Image%202026-01-24%20at%2021.27.04.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/h37e03o9_WhatsApp%20Image%202026-01-24%20at%2021.27.04%2811%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/fua6l25c_WhatsApp%20Image%202026-01-24%20at%2021.27.04%2810%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/ycwcas5l_WhatsApp%20Image%202026-01-24%20at%2021.27.04%286%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/m7fudtkz_WhatsApp%20Image%202026-01-24%20at%2021.27.04%285%29.jpeg",
  "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/44oelo1z_WhatsApp%20Image%202026-01-24%20at%2021.27.04%287%29.jpeg"
];

export const galleryVideos = [
  {
    url: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/cib82z68_WhatsApp%20Video%202026-01-24%20at%2021.27.04%282%29.mp4",
    title: "Rotativa em Funcionamento",
    thumbnail: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/flk0mvrh_WhatsApp%20Image%202026-01-24%20at%2021.27.04%281%29.jpeg"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/k9wutao4_WhatsApp%20Video%202026-01-24%20at%2021.27.04%281%29.mp4",
    title: "Costelão na Rotativa",
    thumbnail: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/flk0mvrh_WhatsApp%20Image%202026-01-24%20at%2021.27.04%281%29.jpeg"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/375pfgeb_WhatsApp%20Video%202026-01-24%20at%2021.27.04.mp4",
    title: "Rotativa Gaúcha em Ação",
    thumbnail: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/flk0mvrh_WhatsApp%20Image%202026-01-24%20at%2021.27.04%281%29.jpeg"
  }
];

// Fotos de embalagem e envio
export const shippingImages = [
  {
    image: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/4j0akcjn_WhatsApp%20Image%202026-01-24%20at%2021.27.04%289%29.jpeg",
    caption: "Embalagem reforçada"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/g91h5xph_WhatsApp%20Image%202026-01-24%20at%2021.27.04%288%29.jpeg",
    caption: "Proteção com plástico bolha"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/h37e03o9_WhatsApp%20Image%202026-01-24%20at%2021.27.04%2811%29.jpeg",
    caption: "Pronta para envio"
  }
];

// Área de clientes - fotos/vídeos de clientes satisfeitos
export const customerGallery = [
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_produtos-gaucha/artifacts/flk0mvrh_WhatsApp%20Image%202026-01-24%20at%2021.27.04%281%29.jpeg",
    caption: "Cliente preparando costelão",
    location: "RS"
  }
];
